<template>
  <main>
    <div class="d-flex mob-flex-direction position-relative flex-column" style="padding-top: 229px;">
      <div class="d-flex">
        <div class="container__headings col-sm-12 col-md-6 col-lg-7 d-flex flex-column w-100">
          <div class="serviceTypeButtons align-items-center align-items-md-start">
            <ButtonComponent
                id="rentButton"
                class="typeButtons me-lg-3"
                :class="[serviceType === ServiceTypes.SERVICE_RENT ? 'active' : null]"
                v-on:click="onServiceTypeChange(ServiceTypes.SERVICE_RENT)"
            >
              <template #btnContent>
                {{ $t('minibus_rental') }}
              </template>
            </ButtonComponent>

            <ButtonComponent
                id="transportationButton"
                class=" typeButtons"
                :class="[serviceType === ServiceTypes.SERVICE_TRANSPORTATION ? 'active' : null]"
                v-on:click="onServiceTypeChange(ServiceTypes.SERVICE_TRANSPORTATION)"
            >
              <template #btnContent>
                {{ $t('passenger_transportation') }}
              </template>
            </ButtonComponent>
          </div>

          <div class="serviceType mt-lg-5 mt-4 ms-4 ms-md-0">
            <template v-if="serviceType === ServiceTypes.SERVICE_RENT">
              <CheckBoxComponent @onClick="isWithDriver" :state="store.state.order.withDriver" :id="'withDriver'" name="withDriver"
                                 class="checkbox-default">
                <template #checkbox-text>
                  <label class="ml-5" for="withDriver">{{ $t('minibus_rent_with_driver') }}</label>
                </template>
              </CheckBoxComponent>
            </template>

            <template v-if="serviceType === ServiceTypes.SERVICE_TRANSPORTATION">
              <CheckBoxComponent @onClick="isRoundTrip" :state="store.state.order.roundTrip" :id="'roundTrip'" name="roundTrip"
                                 class="checkbox-default">
                <template #checkbox-text>
                  <label class="ml-5" for="roundTrip">{{ $t('round_trip') }}</label>
                </template>
              </CheckBoxComponent>
            </template>
          </div>
        </div>
      </div>

      <div class="start-0 w-100 formComponent mt-lg-4 mt-md-3 mt-sm-2">
        <template v-if="serviceType === ServiceTypes.SERVICE_RENT" >
          <RentComponent
              :with-driver="store.state.order.withDriver"
          />
        </template>

        <template v-if="serviceType === ServiceTypes.SERVICE_TRANSPORTATION">
          <TransportationComponent
              :round-trip="store.state.order.roundTrip"
          />
        </template>
      </div>
    </div>

  </main>
</template>

<script lang="ts">
import './servicesIframePage.scss';
import {defineComponent} from 'vue';

// @ts-ignore
import RentComponent from '../../components/Forms/Rent/RentComponent.vue';
// @ts-ignore
import TransportationComponent from '../../components/Forms/Transportation/TransportationComponent.vue';
// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../../components/CheckBox/CheckBoxComponent.vue";

import {mapState, useStore} from "vuex";

import {ServiceTypes} from "../../interfaces/enums/ServiceTypes.enum";
import type {IOrderState} from "@/store/states/IOrderState.interface";


export default defineComponent({
  name: 'ServicesIframePage',
  components: {
    CheckBoxComponent,
    ButtonComponent,
    RentComponent,
    TransportationComponent
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },

    computed: {
        ...mapState<IOrderState>('order', {
            serviceType: (state: IOrderState) => state.serviceType,
            withDriver: (state: IOrderState) => state.withDriver,
            roundTrip: (state: IOrderState) => state.roundTrip,
        }),
    },

  data() {
    return {
      ServiceTypes: ServiceTypes
    }
  },

  methods: {
    onServiceTypeChange: function (serviceType: ServiceTypes): void {
      let payload = <{ prop: string, value: boolean } | null>null;

      switch (serviceType) {
        case ServiceTypes.SERVICE_RENT:
          payload = {prop: 'roundTrip', value: false};
          break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
          payload = {prop: 'withDriver', value: false};
          break;
      }

      this.store.dispatch('order/updateInitStates', [payload]);
      this.store.dispatch('order/updateInitStates', [{prop: 'serviceType', value: serviceType}]);

    },

    isWithDriver: function (evt: any): void {
      this.store.dispatch('order/updateInitStates', [{prop: 'withDriver', value: evt.target.checked}]);
    },

    isRoundTrip: function (evt: any): void {
      this.store.dispatch('order/updateInitStates', [{prop: 'roundTrip', value: evt.target.checked}]);
    }
  },


  created() {
    let lastScrollHeight = 0;

    function iFrameResize() {
      const elem = document.querySelector("body");

      if (! elem) {
        return;
      }

      if (elem.offsetHeight === lastScrollHeight) {
        return;
      }

      const bottomModalHeight = 130;

      const height = elem.offsetHeight + bottomModalHeight;
      lastScrollHeight = elem.offsetHeight;

      parent.postMessage("resize::" + height,"*");
    }

    setInterval(iFrameResize, 100);
  },
});

</script>



